import { __extends } from "tslib";
import { StartFaceDetectionRequest, StartFaceDetectionResponse } from "../models/index";
import { deserializeAws_json1_1StartFaceDetectionCommand, serializeAws_json1_1StartFaceDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartFaceDetectionCommand = /** @class */ (function (_super) {
    __extends(StartFaceDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartFaceDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartFaceDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartFaceDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartFaceDetectionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartFaceDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartFaceDetectionCommand(input, context);
    };
    StartFaceDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartFaceDetectionCommand(output, context);
    };
    return StartFaceDetectionCommand;
}($Command));
export { StartFaceDetectionCommand };
//# sourceMappingURL=StartFaceDetectionCommand.js.map